import {getValueCeiling} from '../../../helpers/get-value-ceiling.js'

//Danger Meter
export function getDangerMeterChanges(action, combatantMap, currentCombatantStateChanges, combatantModels) {

  //Copy the changes.
  let changes = {
    ...currentCombatantStateChanges
  };

  //Use up the Danger Meter if this is a SUPER attack!
  if (action.isSuper) {
    changes.state[combatantMap.casterId].dangerMeter = 0;
    return changes; //stop here!
  }


  if (action.actionMeta.isBugged) {
    //Stop here. Danger Item is bugged (this one is BEFORE the true Bugging check, so it's weird.)
    return changes; //stop here!
  }


  //Boost Danger Meter for USING a move (not an explicit Danger Meter boosting action)
  if (action.increaseDangerMeterOnUse > 0) {
    const casterModel = combatantModels[combatantMap.casterId];

    //Apply the new value to state
    changes.state[combatantMap.casterId].dangerMeter = getValueCeiling(
      casterModel.dangerMeter + action.increaseDangerMeterOnUse, 100
    ); //max Danger Meter at 100;
  }


  //Explicit Danger Meter boosting action (EX: danger boost item)
  if (action.affectTargetDangerMeter > 0) {
    combatantMap.targetIds.forEach(targetId => {
      const targetModel = combatantModels[targetId];

      //Apply the new value to target
      changes.state[targetId].dangerMeter = getValueCeiling(
        targetModel.dangerMeter + action.affectTargetDangerMeter, 100
      ); //max Danger Meter at 100;

    })
  }


  return changes;
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/description/danger-meter.js